/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import { __extends } from "tslib";
import * as msRest from "@azure/ms-rest-js";
var packageName = "@azure/cognitiveservices-face";
var packageVersion = "5.0.0";
var FaceClientContext = /** @class */ (function (_super) {
    __extends(FaceClientContext, _super);
    /**
     * Initializes a new instance of the FaceClientContext class.
     * @param endpoint Supported Cognitive Services endpoints (protocol and hostname, for example:
     * https://westus.api.cognitive.microsoft.com).
     * @param credentials Subscription credentials which uniquely identify client subscription.
     * @param [options] The parameter options
     */
    function FaceClientContext(credentials, endpoint, options) {
        var _this = this;
        if (endpoint == undefined) {
            throw new Error("'endpoint' cannot be null.");
        }
        if (credentials == undefined) {
            throw new Error("'credentials' cannot be null.");
        }
        if (!options) {
            options = {};
        }
        if (!options.userAgent) {
            var defaultUserAgent = msRest.getDefaultUserAgentValue();
            options.userAgent = packageName + "/" + packageVersion + " " + defaultUserAgent;
        }
        _this = _super.call(this, credentials, options) || this;
        _this.baseUri = "{Endpoint}/face/v1.0";
        _this.requestContentType = "application/json; charset=utf-8";
        _this.endpoint = endpoint;
        _this.credentials = credentials;
        return _this;
    }
    return FaceClientContext;
}(msRest.ServiceClient));
export { FaceClientContext };
//# sourceMappingURL=faceClientContext.js.map